<template>
  <v-card>
    <v-card-title class="d-flex align-center justify-space-between">
      <span class="headline">Alben</span>
      <v-btn icon @click="$emit('refresh')">
        <v-icon>mdi-sync</v-icon>
      </v-btn>
    </v-card-title>
    <v-list two-line>
      <v-list-item v-for="alb in albums" :key="alb.id" @click="$emit('select', alb)">
        <v-list-item-content>
          <v-list-item-title>{{ alb.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ alb.mediaItemsCount || 0 }} Fotos</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card-actions>
      <v-btn block color="primary" @click="$emit('create')">+ Neues Album</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default { props: ["albums"] }
</script>
